module.exports = __webpack_public_path__ + "img/star-mdi.e9ed6ed2.svg";